import { client, useApiGet, request, apiHeaders } from "./_base";

export interface ProductCharacteristics {
  id?: number;
  characteristic_code: string;
  characteristic_description: string;
  labelinggroup_id: number;
  paltrack_label_processed: number;
  created_at: Date;
  updated_at: Date;
  username: number;
  // These are for the old fields - which will be removed again
  product_group_code: string;
  product_characteristic_code: string;
  product_characteristic_description: string;
}

interface ProductCharacteristicsFull extends ProductCharacteristics {
  group_code: string;
  group_description: string;
  edited_by: string;
}

const endpoint = "productcharacteristics";

export const productcharacteristics = client<ProductCharacteristics>(endpoint, (item) => ({
  ...item,
}));

export const getProductCharacteristicsFull = async (): Promise<ProductCharacteristicsFull[]> => useApiGet(`${endpoint}/ext/all`);

export const upsertProductCharacteristic = async (body: { id: string; data: any }): Promise<void> => {
  const content = JSON.stringify(body);
  const result = await request(`${endpoint}/ext/upsertProductCharacteristic`, {
    method: "POST",
    headers: apiHeaders(content),
    body: content,
  });
  const resp = await result.json();
  if (result.status == 500) {
    throw resp;
  }
  return resp.data;
};